import Image, {StaticImageData} from "next/image"
import {FC} from "react"
import cn from "classnames"
import styles from "./course.module.css"

interface OctopussyProps {
  image: StaticImageData
  title: string
  subtitle: string
}

export const Octopussy: FC<OctopussyProps> = ({image, title, subtitle}) => (
  <div
    className={cn(
      "w-[340px] h-full p-5 border-2 border-black-500 tablet:border-0",
      styles.octopussy
    )}
  >
    <Image src={image} layout="responsive" alt="octopussy" />
    <h5 className="mt-5">{title}</h5>
    <p className="mt-3 text-body-6 text-text-gray">{subtitle}</p>
  </div>
)
